<template>
    <div class="my-4">
        <div class="mb-4 flex justify-end text-xs text-primary tracking-wide">
            {{ message }}
        </div>
        <Slider
            v-model="value"
            v-bind="slider"
            @change="change"
            :classes="{
                target: 'relative box-border user-select-none touch-none tap-highlight-transparent touch-callout-none disabled:cursor-not-allowed',
                focused: 'slider-focused',
                tooltipFocus: 'slider-tooltip-focus',
                tooltipDrag: 'slider-tooltip-drag',
                ltr: 'slider-ltr',
                rtl: 'slider-rtl',
                horizontal: 'slider-horizontal h-0.5',
                vertical: 'slider-vertical w-1.5 h-80',
                textDirectionRtl: 'slider-txt-rtl',
                textDirectionLtr: 'slider-txt-ltr',
                base: 'w-full h-full relative z-1 bg-gray-200 rounded',
                connects: 'w-full h-full relative overflow-hidden z-0 rounded',
                connect:
                    'absolute z-1 top-0 right-0 transform-origin-0 transform-style-flat h-full w-full bg-secondary cursor-pointer tap:duration-300 tap:transition-transform disabled:bg-gray-400 disabled:cursor-not-allowed',
                origin: 'slider-origin absolute z-1 top-0 right-0 transform-origin-0 transform-style-flat h-1/10 w-1/10 h:h-0 txt-rtl-h:left-0 txt-rtl-h:right-auto v:w-0 tap:duration-300 tap:transition-transform',
                handle: 'absolute rounded-full bg-secondary border-0 cursor-grab focus:outline-none h:w-4 h:h-4 h:-top-1.5 h:-right-2 txt-rtl-h:-left-2 txt-rtl-h:right-auto v:w-4 v:h-4 v:-top-2 v:-right-1.25 disabled:cursor-not-allowed',
                touchArea: 'h-full w-full',
                tooltip:
                    'absolute block text-sm font-semibold whitespace-nowrap py-1 px-1.5 min-w-5 text-center text-white rounded border border-green-500 bg-secondary transform h:-translate-x-1/2 h:left-1/2 h:bottom-6 h:arrow-bottom v:-translate-y-1/2 v:top-1/2 v:right-6 v:arrow-right disabled:bg-gray-400 disabled:border-gray-400 merge-h:translate-x-1/2 merge-h:left-auto merge-h:bottom-3.5 merge-v:-translate-x-4 merge-v:top-auto merge-v:right-1 tt-focus:hidden tt-focused:block tt-drag:hidden tt-dragging:block',
                tooltipHidden: 'slider-tooltip-hidden',
                active: 'slider-active cursor-grabbing',
                draggable: 'cursor-ew-resize v:cursor-ns-resize',
                tap: 'slider-state-tap',
                drag: 'slider-state-drag',
            }"
        />
    </div>
</template>

<script>
import Slider from "@vueform/slider";

export default {
    components: {
        Slider,
    },
    props: {
        min: {
            type: Number,
            default: 0,
        },
        max: {
            type: Number,
            default: 100,
        },
        step: {
            type: Number,
            default: 1,
        },
        tooltips: {
            type: Boolean,
            default: false,
        },
        format: {
            type: Object,
            default: null,
        },
        modelValue: {
            type: [Number, Array],
        },
    },
    mounted() {
        this.slider.min = this.min;
        this.slider.max = this.max;
        this.slider.step = this.step;
        this.slider.tooltips = this.tooltips;
        this.slider.format = this.format;
    },
    data() {
        return {
            value: 0,
            slider: {
                min: 0,
                max: 100,
                step: 1,
                tooltips: false,
                format: null,
            },
        };
    },
    watch: {
        modelValue(newValue) {
            this.value = newValue;
        },
    },
    computed: {
        message() {
            let message = this.value;

            if (
                this.value &&
                Array.isArray(this.value) &&
                this.value.length === 2
            ) {
                const lowerBound = this.value[0];
                const upperBound = this.value[1];
                if (
                    lowerBound === this.slider.min &&
                    upperBound === this.slider.max
                ) {
                    message = "Any";
                } else if (lowerBound === this.slider.min) {
                    message = "Up to " + this.formatValue(upperBound);
                } else if (upperBound === this.slider.max) {
                    message = this.formatValue(lowerBound) + " or more";
                } else {
                    message =
                        this.formatValue(lowerBound) +
                        " - " +
                        this.formatValue(upperBound);
                }
            } else if (this.value && !Array.isArray(this.value)) {
                if (this.value < this.slider.max) {
                    message = "Up to " + this.formatValue(this.value);
                } else {
                    message = "Any";
                }
            }

            return message;
        },
    },
    methods: {
        change() {
            this.$emit("change", this.value);
        },
        formatValue(value) {
            let result = value;

            if (value && this.format) {
                const prefix = this.format.hasOwnProperty("prefix")
                    ? this.format.prefix
                    : "";
                const suffix = this.format.hasOwnProperty("suffix")
                    ? this.format.suffix
                    : "";
                const decimals =
                    this.format.hasOwnProperty("decimals") &&
                    !isNaN(this.format.decimals)
                        ? parseInt(this.format.decimals)
                        : 0;
                const thousand = this.format.hasOwnProperty("thousand")
                    ? this.format.thousand
                    : null;

                const re =
                    "\\d(?=(\\d{3})+" + (decimals > 0 ? "\\D" : "") + ")";
                const num = value.toFixed(Math.max(0, ~~decimals));

                result = num.replace(
                    new RegExp(re, "g"),
                    "$&" + (thousand || "")
                );

                result = prefix + result + suffix;
            }

            return result;
        },
    },
};
</script>
